// extracted by mini-css-extract-plugin
export default {"projects":"Project_projects__GA634","project_image":"Project_project_image__ZlZzv","flex":"Project_flex__MugfZ"};